import request from '@/utils/request'

export function getTextEmoticonsApi(roomId, gType, cId, tId) {
    return request({
        url: '/live-chat/wnTextEmoticons/list',
        headers: {
            isToken: false,
            repeatSubmit: false,
            isEncrypt: false
        },
        method: 'get'
    })
}

export function getLiveChatProductsApi(query) {
    return request({
        url: '/live-chat/liveChat/productInfo/list',
        headers: {
            isToken: true,
            repeatSubmit: true,
            isEncrypt: true
        },
        method: 'get',
        params: query
    })
}

export function getLiveChatProductsByCoreApi(query) {
    return request({
        url: '/live-chat/liveChat/productInfo/list/core',
        headers: {
            isToken: true,
            repeatSubmit: true,
            isEncrypt: true
        },
        method: 'get',
        params: query
    })
}
